import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, tap } from 'rxjs';
import { ErrorHandlerService } from 'src/app/share/services/error-handler.service';
import { environment } from 'src/environments/environment';
const apiurl = environment.apiUrl;
@Injectable({
  providedIn: 'root'
})
export class QuizResultService {

  constructor(private http: HttpClient, private errorHandler: ErrorHandlerService,) { }
  getItems(param: HttpParams = null): Observable<any> {
      return this.http.get<any>(`${apiurl}/quiz-result`, { params: param }).pipe(
        tap((response) => response),
        catchError((error) => this.errorHandler.handleError(error))
      );
    }
  
  generateWinner(id:string,param: HttpParams = null){
    return this.http.put<any>(`${apiurl}/quiz-result/${id}`, { params: param }).pipe(
        tap((response) => response),
        catchError((error) => this.errorHandler.handleError(error))
      );
  }

  getWinner(param: HttpParams = null){
    return this.http.get<any>(`${apiurl}/quiz-result/winner`, { params: param }).pipe(
        tap((response) => response),
        catchError((error) => this.errorHandler.handleError(error))
      );
  }
}
